// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2Dta7","containerItemsCenter":"Skeleton_containerItemsCenter__Oyt3k"};